import FacebookCard from "./FacebookCard";
import InstagramCard from "./InstagramCard";
import fb_cover from "../../../assets/images/ahd_facebook_cover.jpg"
import ahd_logo from '../../../assets/images/ahd_profile.png' 

function SocialMedia() {
  return (
    <div >
      <div className="section-title ">
            <h2 className="text-anime">Social Media</h2>
      </div>
      <div className="card-grid pb-4 px-4">
        <FacebookCard
          cover={fb_cover}
          followers="5.4K"
          profileImg={ahd_logo}
          link="https://www.facebook.com/allhomedesire/"
        />
        <InstagramCard
          profileImg={ahd_logo}
          followers="4,477"
          posts="53"
          link="https://instagram.com/allhomedesire"
        />
      </div>

    </div>
  );
}

export default SocialMedia;
